<i *ngIf="searchFieldStyle == false" class="ri-search-line search-icon fs-14 position-absolute"
    style=" padding-top: 7px; padding-left: 12px; color: #878a99; z-index: 1;"></i>
<ng-select class="custom rounded flex-grow-1" [ngClass]="{ 'bg-light': (searchFieldStyle == false) }"
    [ngStyle]="{'padding-left': (searchFieldStyle == false) ? '30px' :''} " [items]="listItems" [multiple]="true"
    [addTag]="addCustomEmail" [selectOnTab]="true" [typeahead]="searchTerm$" [maxSelectedItems]="maxItems"
    [isOpen]="(searchTermLength > minLengthTerm)" [minTermLength]="minLengthTerm" (clear)="arrayCleared()"
    (change)="addModelToArray(selectedModelsArray)" [(ngModel)]="selectedModelsArray"
    [placeholder]="searchPlaceHolderText">

    <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ng-value-icon left" (click)="clear(item)">×</span>
        <span class="ng-value-label text-white">
            <span *ngIf="(item.email == undefined || item.email.length == 0) else elseValidEmail"
                class="orange bg-transparent" placement="bottom" ngbTooltip='Invalid Email'
                tooltipClass="toolTipOverFlow">
                <span *ngIf="item.fullName else elseSplitName">
                    {{item.fullName}}
                </span>
                <ng-template #elseSplitName>
                    <span>
                        {{item.name}} {{item.lastName}}
                    </span>
                </ng-template>
            </span>
            <ng-template #elseValidEmail>
                <span *ngIf="item.fullName else elseSplitName">
                    {{item.fullName}}
                </span>
                <ng-template #elseSplitName>
                    <span>
                        {{item.name}} {{item.lastName}}
                    </span>
                </ng-template>
            </ng-template>
        </span>

        <span *ngIf="searchFieldStyle">
            <span *ngIf="item.status" class="fs-12 p-0 bg-transparent" style="cursor:default !important; "
                [ngClass]=statusTextClass(item.status) placement="bottom" [ngbTooltip]='statusText(item.status)'
                tooltipClass="toolTipOverFlow">
                <i *ngIf="item.status == enumCalendarEventStatus.Tentative " class="ri-question-line "></i>
                <i *ngIf="item.status == enumCalendarEventStatus.Declined " class="ri-close-circle-line "></i>
                <i *ngIf="item.status == enumCalendarEventStatus.Accepted " class="ri-checkbox-circle-line "></i>
            </span>
        </span>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label d-flex align-items-center">

            <span class="mx-2 d-flex align-items-center">
                <i *ngIf="item.modelType == enumEntityType.Client"
                    class="avatar-xxs rounded-circle me-2 bx bx-user-circle icon nav-icon rounded-circle blue" style="font-size: x-large;"></i>
                <i *ngIf="item.modelType == enumEntityType.User"
                    class=" avatar-xxs rounded-circle me-2 bx bx-user icon nav-icon rounded-circle orange" style="font-size: x-large;"></i>
                <i *ngIf="item.modelType == enumEntityType.Account"
                    class="avatar-xxs rounded-circle me-2 bx bxs-contact icon nav-icon rounded-circle purple" style="font-size: x-large;"></i>
            </span>
            <div class="d-flex" style="flex-direction: column;">
                <span *ngIf="item.fullName else elseSplitName">
                    {{item.fullName}} 
                </span>
                <ng-template #elseSplitName>
                    <span>
                        {{item.name}} {{item.lastName}}
                    </span>
                </ng-template>
                <span class="px-2 fs-10">
                    {{item.email}} 
                    <span *ngIf="item.email && item.phoneNumber">
                        ||
                    </span>
                    {{item.phoneNumber}} 
                </span>
            </div>
            
            <span *ngIf="searchFieldStyle" class=" d-flex align-items-center">
                <span *ngIf="item.email == undefined || item.email.length == 0" class="mx-2 d-flex align-items-center"
                    placement="bottom" ngbTooltip='Invalid Email' tooltipClass="toolTipOverFlow">
                    <i class="font-size-14 rounded-circle ri-close-circle-line red bg-transparent"></i>
                </span>
            </span>
        </span>
    </ng-template>

    <ng-template ng-tag-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label ">
            <span style="font-size: 80% !important; ">
                Add Custom Email:
            </span>
            <span [ngStyle]="{'color': (validEmailString(searchTerm)) ? '':'#ed5e5e'}">
                "{{searchTerm}}"
            </span>
            <span *ngIf="!validEmailString(searchTerm)" style="color:'#ed5e5e';">
                - Invalid Email
            </span>
        </span>
    </ng-template>

</ng-select>